import styled from 'styled-components'

export const PanelRoot = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  background: ${p => p.theme.palette.colors.backgroundStrong};
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  box-shadow: 0 18px 34px ${p => p.theme.palette.colors.shadowStrong};
  overflow: hidden;
`;

export const TabHeader = styled.div.attrs({})`
  display: flex;
  gap: 24px;
  padding: 0 24px;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
`;

export const TabButton = styled.button.attrs({})`
  min-height: 56px;
  padding: 0;
  border: 0;
  border-bottom: 2px solid ${p => p.active ? p.theme.palette.blue.main : 'transparent'};
  background: transparent;
  cursor: pointer;
  font-family: Gilroy;
  font-size: 16px;
  line-height: 24px;
  font-weight: ${p => p.active ? 700 : 400};
  color: ${p => p.active ? p.theme.palette.blue.main : p.theme.palette.colors.muted};
`;

export const PanelContent = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 24px;
`;

export const ContentEyebrow = styled.div.attrs({})`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
`;

export const CategoryBadge = styled.div.attrs({})`
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 5px 12px;
  border-radius: 999px;
  background: ${p => p.theme.palette.colors.badgeMuted};
  font-family: Poppins;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${p => p.theme.palette.colors.text};
`;

export const LessonLabel = styled.div.attrs({})`
  font-family: Lato;
  font-size: 13px;
  line-height: 1.5;
  color: ${p => p.theme.palette.blue.main};
`;

export const PanelTitle = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: 30px;
  line-height: 1.08;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.text};

  @media(max-width: 991px){
    font-size: 26px;
  }
`;

export const PanelMeta = styled.div.attrs({})`
  font-family: Lato;
  font-size: 14px;
  line-height: 1.6;
  color: ${p => p.theme.palette.colors.subdued};
`;

export const ActionHint = styled.div.attrs({})`
  font-family: Lato;
  font-size: 13px;
  line-height: 1.5;
  color: ${p => p.theme.palette.colors.subdued};
  margin-top: 8px;
`;

export const ApprovalStatus = styled.div.attrs({})`
  align-self: flex-start;
  border: 1px solid ${p => p.approved
    ? p.theme.palette.success.main
    : p.rejected
      ? p.theme.palette.error.main
      : p.theme.palette.warning.main};
  border-radius: 999px;
  color: ${p => p.approved
    ? p.theme.palette.success.main
    : p.rejected
      ? p.theme.palette.error.main
      : p.theme.palette.warning.main};
  font-family: Lato;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 700;
  padding: 6px 10px;
  text-transform: capitalize;
`;

export const BodyText = styled.div.attrs({})`
  font-family: Lato;
  font-size: 16px;
  line-height: 1.7;
  color: ${p => p.theme.palette.colors.muted};
  max-width: 880px;

  h1,
  h2,
  h3 {
    font-family: Gilroy;
    font-size: 24px;
    line-height: 1.2;
    font-weight: 700;
    color: ${p => p.theme.palette.colors.text};
    margin: 0 0 18px;
  }

  p {
    margin: 0 0 18px;
  }

  a {
    color: ${p => p.theme.palette.blue.main};
  }
`;

export const TranscriptText = styled.div.attrs({})`
  font-family: Lato;
  font-size: 16px;
  line-height: 1.52;
  color: ${p => p.theme.palette.colors.muted};
  max-width: 880px;
  white-space: pre-wrap;
`;

export const TranscriptBody = styled.div.attrs({})`
  max-height: 560px;
  overflow-y: auto;
  padding-right: 10px;

  ${BodyText},
  ${TranscriptText} {
    margin: 0;
  }

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(153, 161, 175, 0.45);
    border-radius: 999px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(153, 161, 175, 0.7);
  }

  @media(max-width: 991px){
    max-height: 460px;
  }
`;

export const ActionsStrip = styled.div.attrs({})`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 240px));
  gap: 12px;
  align-items: center;
  margin-top: -4px;

  > * {
    min-width: 0;
  }

  @media(max-width: 640px){
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const SurveyAction = styled.div`
  width: 240px;
  max-width: 100%;

  .MuiButton-root {
    min-width: 0;
    padding-inline: 14px;
    font-size: 14px;
    white-space: nowrap;
  }

  @media(max-width: 640px){
    width: 100%;
  }
`;
